import React, {useState} from 'react';
import {NeuroMessage, usePages, AnswersList, RenderOnlyFor} from '@ignitesales/neuro-application';
import ContactFormModal from '../../../../../../../shared/js/components/ContactFormModal.jsx';
import Footer from '../../../../../../../shared/js/components/Footer.jsx';
import Product from "../Product.jsx";
import Collapsible from "react-collapsible";
import StickyHeader from '../../../../../../../shared/js/components/StickyHeader.jsx';
import Header from '../Header.jsx';

function SummaryPage({ componentClass, productsList }) {
    const { goToPreviousPage } = usePages();
    const [ showContactForm, setShowContactForm ] = useState(false);
    const pageName = `${componentClass}_page`

    return (
        <div className={componentClass} id={pageName}>
            <img src={"/classpath/assets/images/background-curve.png"} alt="background-curve" className={`${componentClass}__background`} />

            <RenderOnlyFor forSummaryPage={true}>
              <Header />
            </RenderOnlyFor>

            <StickyHeader setShowContactForm={setShowContactForm} pageName={pageName} />

            <div className="container">
                <div className={`${componentClass}__header`}>
                    <div className="header-text">
                        <NeuroMessage id="summary.title" tagName="h1"/>
                        <NeuroMessage id="summary.subtext" tagName="p"/>
                    </div>
                    <div className="header-buttons">
                        <RenderOnlyFor forSummaryPage={true}>
                            <button className="btn complete-btn" onClick={() => setShowContactForm(true)}>
                                <i className="ion-md-checkmark-circle-outline" />
                                <NeuroMessage id='summary.completeBtn' />
                            </button>
                        </RenderOnlyFor>
                    </div>
                </div>

                <div className={`${componentClass}__products`}>
                    { productsList.map(p => <Product key={ p.id } product={p}/>) }
                </div>

                <div className={`${componentClass}__answers`}>
                    <Collapsible trigger={<div className='answersListHeader'>View Answers</div>}>
                        <AnswersList linkToQuestion />
                    </Collapsible>
                </div>

                <RenderOnlyFor forSummaryPage={true}>
                    <div className={`${componentClass}__navigation`}>
                        <button className="btn back-btn" onClick={goToPreviousPage}>
                            <i className="ion-md-arrow-back"/>
                            <NeuroMessage id='summary.previousPageBtn'/>
                        </button>
                    </div>
                </RenderOnlyFor>
            </div>

            <Footer/>

            <ContactFormModal
                isOpen={showContactForm}
                onComplete={() => setShowContactForm(false)}
                onClose={() => setShowContactForm(false)}
            />
        </div>
    );
}

export default SummaryPage;

